/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

export type ResourceProjectPropertyKey = `${string}___${string}`;

export const createProjectPropertyResource = <T,>({
	propertyKey,
	maxAge = 24 * 60 * 60 * 1000, // 24 hours
}: {
	propertyKey: string;
	maxAge?: number;
}): RouteResource<T | null> =>
	createResource({
		type: `CSM_PROJECT_PROPERTIES___${propertyKey}`,
		getKey: ({
			match: {
				params: { projectKey },
			},
		}): ResourceProjectPropertyKey => `${projectKey}___${propertyKey}`,
		getData: async ({
			match: {
				params: { projectKey },
			},
		}) =>
			performGetRequest<{ key: string; value: T } | null>(
				`/rest/api/3/project/${projectKey}/properties/${propertyKey}`,
			).then((data) => data?.value ?? null),
		maxAge,
	});
